// Simple mapping of category to colors similar to the C# helper.
// Accepts number (enum value) or string name. Returns { bg, fg, border }
export function getCategoryColors(category) {
  const neutral = { bg: "#ffffff", fg: "#212529", border: "#ced4da" };
  if (category === null || category === undefined) return neutral;
  // Normalize numeric to string name for switch
  let name = category;
  if (typeof category === "number") {
    // Map numeric codes based on backend enum
    const mapping = {
      0: "None",
      1: "Main",
      2: "Movie",
      3: "Anime",
      4: "Talk",
      5: "Workshop",
      6: "Contest",
      7: "Special",
      9: "ProContest",
      10: "BookLaunch",
      11: "Quiz",
      12: "AuthorTalk",
    };
    name = mapping[category] || "None";
  }

  switch (name) {
    case "Contest":
    case "Quiz":
      return { bg: "#9ecb31", fg: "#2f1d00", border: "#6EA010" };
    case "Main":
      return { bg: "#f67d82", fg: "#2f1d00", border: "#C40000" };
    case "BookLaunch":
    case "AuthorTalk":
    case "Special":
      // Softer peachy orange for book/author related items
      return { bg: "#faca9d", fg: "#3a2400", border: "#E0A54A" };

    case "Talk":
      return { bg: "#cccdfd", fg: "#1f1535", border: "#B4B8FF" };
    case "Anime":
      return { bg: "#fefda1", fg: "#3a3000", border: "#FFEB3B" };
    case "Movie":
    case "ProContest":
      // Richer saturated blue (approx from screenshot)
      return { bg: "#a0cefc", fg: "#3d0d24", border: "#002ECC" };
    case "Workshop":
      return { bg: "#f799cb", fg: "#3d0d24", border: "#EC6FB7" };
    default:
      return neutral;
  }
}

export const categoryBackground = (c) => getCategoryColors(c).bg;
export const categoryForeground = (c) => getCategoryColors(c).fg;
export const categoryBorder = (c) => getCategoryColors(c).border;
